import { createSelector } from 'reselect'

export const selectNotifications = state => state.notifications

export const createSelectNotification = id => createSelector(
  selectNotifications,
  notifications => notifications.find(notification => notification.id === id)
)
